import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["EventOnMount"] */ "/vercel/path0/src/components/analytics/event-on-mount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSettingsLink"] */ "/vercel/path0/src/components/layout/cookie-settings-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteNav"] */ "/vercel/path0/src/components/layout/site-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnchorScan"] */ "/vercel/path0/src/components/marketing/animated/anchor-scan.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Boardroom"] */ "/vercel/path0/src/components/marketing/animated/boardroom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GaltonBoard"] */ "/vercel/path0/src/components/marketing/animated/galton-board.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NinePhaseAnalysis"] */ "/vercel/path0/src/components/marketing/animated/nine-phase-analysis.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PipelineLoop"] */ "/vercel/path0/src/components/marketing/animated/pipeline-loop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SampleBrief"] */ "/vercel/path0/src/components/marketing/animated/sample-brief.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TelemetryStrip"] */ "/vercel/path0/src/components/marketing/animated/telemetry-strip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/marketing/btn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReportsHeroStats"] */ "/vercel/path0/src/components/marketing/reports/reports-hero-stats.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/marketing/reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TickerBar"] */ "/vercel/path0/src/components/marketing/ticker-bar.tsx");
